import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { NotificationManager } from "react-notifications";
import MainContainer from "../../layouts/container/mainContainer";
import { FormProvider, useForm } from "react-hook-form";
import "../../styles/pages/login.scss";
import Button from "../../components/buttons/button";
import Modal from "@mui/material/Modal";
import { callApi, getAgents, saveAssingAgent } from "../../services/apiService";
import AutocompleteSelect from "../../components/forms/inputsMui/autocomplete";

const AssignAgentModal = ({
  open,
  onClose,
  loadDataTable,
  postulationIds,
  setCheckedPostulationIds,
}) => {
  const { t } = useTranslation();
  const [agencyUsers, setAgencyUsers] = useState([]);

  const validations = {
    agent: {
      required: { value: true, message: t("userList.required") },
    },
  };

  const defaultValues = {};
  const methods = useForm({ defaultValues });
  const {
    control,
    register,
    setValue,
    watch,
    handleSubmit,
    reset,
    formState: { errors },
  } = methods;

  const cleanForm = () => {
    setValue("agent", "");
  };

  useEffect(() => {
    if (!open) return;
    callApi(getAgents, (data) => {
      setAgencyUsers([{ id: -1, name: t("userList.noAgent") }, ...data]);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const onSubmit = (data) => {
    const submitData = {
      agentId:
        data.agent == -1 || data.agent == -1 ? null : parseInt(data.agent, 10),
      postulationIds: postulationIds,
    };

    callApi(
      () => saveAssingAgent(submitData),
      () => {
        NotificationManager.success(t("form.success"));
        onCloseHandle();
        setCheckedPostulationIds([]);
        loadDataTable();
      }
    );
  };

  const onCloseHandle = () => {
    cleanForm();
    reset();
    onClose();
  };

  return (
    <>
      <Modal
        open={open}
        onClose={onCloseHandle}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MainContainer class="ww-container-m" showImage={false}>
          <h1 style={{ margin: "20px 0 20px 0" }} className="title">
            {t("userList.asignAgent")}
          </h1>
          <FormProvider {...methods}>
            <form>
              <div className="inputs-style">
                <label>{t("userList.asignAgentLabel")}</label>

                <AutocompleteSelect
                  name="agent"
                  label={t("userList.agents")}
                  options={agencyUsers}
                  register={register}
                  registerOptions={validations}
                  watch={watch}
                  setValue={setValue}
                />
                {watch("agent") == "" && (
                  <span className="text-danger text-small d-block mb-2 validation-margin">
                    {errors.agent && errors.agent.message}
                  </span>
                )}
              </div>
            </form>
          </FormProvider>
          <div>
            <div className="table-btn-group">
              <Button
                type="ww-btn-secondary"
                style={{ margin: "10px" }}
                size="btn-s secondary"
                label={t("main.close")}
                onClick={() => {
                  cleanForm();
                  onCloseHandle();
                }}
              />
              <Button
                size="btn-s"
                label={t("main.send")}
                onClick={handleSubmit(onSubmit)}
              />
            </div>
          </div>
        </MainContainer>
      </Modal>
    </>
  );
};

export default AssignAgentModal;
